<template>
  <RfBaseCard class="gap-3!">
    <div class="flex items-center justify-between">
      <Transition mode="out-in">
        <RfBaseSkeleton v-if="skeleton" height="23" width="189" srLabel="Loading variations" />
        <h2 v-else class="text-heading-1 text-beige-90">Variations</h2>
      </Transition>

      <Transition mode="out-in">
        <RfBaseSkeleton v-if="skeleton" height="40" width="185" />
        <RfButtonNew v-else :disabled="disableAdd" type="quaternary" @click="emit('addVariant')">
          <RfAddIcon class="h-6 w-6" /> Add variation
        </RfButtonNew>
      </Transition>
    </div>

    <RfTable :tableData="tableData" :loading="skeleton" hideTotal>
      <template #thead>
        <RfExperimentVariationsHeader :path="path" />
      </template>
      <template #tbody>
        <template v-if="skeleton">
          <tr v-for="i in 3" :key="i" class="border-beige-10 border-t border-solid">
            <td colspan="6" class="px-4! py-2!">
              <RfBaseSkeleton height="56" />
            </td>
          </tr>
        </template>
        <template v-else>
          <RfExperimentVariationRow
            v-for="variant in variants"
            :key="variant.id"
            :variant="variant"
            :path="path"
            :currExperiment="currExperiment"
            :disabled="disabled"
            @showEditVariant="emit('showEditVariant', variant)"
            @showDeleteModal="emit('showDeleteModal', variant)"
            @showVariantDetails="emit('showVariantDetails', variant)"
          />
        </template>
      </template>
    </RfTable>
  </RfBaseCard>
</template>

<script setup>
import { computed } from "vue";
import RfBaseCard from "@/components/cards/RfBaseCard.vue";
import RfTable from "@/blocks/RfTable/RfTable.vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfAddIcon from "@/components/icons/RfAddIcon.vue";
import RfBaseSkeleton from "@/components/skeletons/RfBaseSkeleton.vue";
import RfExperimentVariationRow from "@/blocks/RfExperiments/RfExperimentVariationRow.vue";
import RfExperimentVariationsHeader from "@/blocks/RfExperiments/RfExperimentVariationsHeader.vue";

const emit = defineEmits([
  "addVariant",
  "showEditVariant",
  "showDeleteModal",
  "showVariantDetails",
]);

const props = defineProps({
  variants: { type: Array, default: () => [] },
  path: { type: Object, default: () => ({}) },
  currExperiment: { type: Object, default: () => ({}) },
  disabled: { type: [Boolean, String], default: false },
  disableAdd: { type: [Boolean, String], default: false },
  skeleton: { type: Boolean, default: false },
});

const tableData = computed(() => ({
  totalCount: props.variants.length,
  showing: props.variants.length,
  loadMore: 0,
}));
</script>
